/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onChangeAsset = /* GraphQL */ `
  subscription OnChangeAsset($areaId: String) {
    onChangeAsset(areaId: $areaId) {
      areaId
      asset {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
    }
  }
`;
export const onChangeAreaTask = /* GraphQL */ `
  subscription OnChangeAreaTask($areaId: String, $vendorId: String) {
    onChangeAreaTask(areaId: $areaId, vendorId: $vendorId) {
      areaId
      task {
        approvedBy
        approvedOn
        asset {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        assetId
        assignee
        assigneeIds {
          assigneeId
          sequence
          isDeleted
          isAccepted
          acceptedOn
          vendorId
          operatorId
        }
        assignedOn
        attachments {
          bucket
          key
          region
          fileName
        }
        completedOn
        createdOn
        createdBy
        data
        duration
        endTime
        eventSource
        isRecurring
        fieldId
        id
        isHardAssignee
        isPlanned
        recurrenceInactive
        priority
        schedule {
          rrule
          startDate
          endDate
          recurrencePattern
          type
          displayUptoDays
          allowPileups
          overwriteEditedOccurrences
        }
        sourceRecurringTaskId
        originalRecurrenceDate
        deletedForRecurrenceDates
        isHardStartTime
        startTime
        status
        taskType {
          id
          duration
          priority
          score
          increment
          name
          schema
          teamId
          tenantId
          fieldId
          isParent
          autoApprove
          workflowVersions {
            version
            workflowSteps {
              workflowStepId
              taskTypeId
              dependsOn
              immediateNextTo
              sameAssigneeAs
              sameStartTimeAs
              formSectionId
              preferredLocationTypeId
              priorityTemplate
              assigneeIds
              sameLocationAs
              autoResolveDependsOn
            }
          }
          publishedVersion
          createdOn
          createdBy
          modifiedOn
          modifiedBy
          isDeleted
          needAcceptance
          enforceTimeSpent
          enforceComment
          enableReassign
          enableAutoAssign
          hasFormAttributes
          isLinkable
          certificates {
            id
            name
            isExpirable
            expiryDate
          }
          skillLevel {
            id
            name
            value
          }
          resolveOnArchive
          partsPicklist
          formSchemaId
          approvalMatrix
          disableCreateOnMobile
          disableAssignOnMobile
          disablePriorityOnMobile
          disableWorkOrderOnMobile
          disableDateOnMobile
          disableAssetOnMobile
          resolveOnGeofence
          excludeByRoutingEngine
          disablePrioritySelectionOnMobile
          disableEditingResolvedOnMobile
          taskTypeCode
          generateMultiple
          globalAttributes
          reminder {
            enableReminder
            reminderTime {
              days
              hours
              minutes
            }
          }
          attachmentIds
          instructionIds
          notification {
            notificationProfile
            notificationConfig {
              actionType
              userTypeForEmail
              userTypeForPushNotification
              sectionsToIncludeInEmail
            }
          }
          notificationProfile
          actionsEnabled
          userType
          fullManualMode
          singleActiveTask
          mandatoryWatcherGroups
          priorityTemplate
          priorityAlias
          rt_id
          needEquipment
          mandatoryAssignee
          autoAssignFirstChildToCreator
          triggerTasksUsingRules
          groups {
            id
            name
          }
          watcherGroupConfig {
            entityId
            entityPicklistWatcherGroupMappingId
            entityType
          }
          generateMultipleLabelName
          isDynamicParentChild
          rollupGlobalAttributes
          allowAssetLevelsInfo
          allowTaskCreationWithResolvedStatus
          autoResolveFirstTask
          defaultLocationTask
          allowedTeamsAsWatchers
        }
        taskTypeId
        tenantId
        parentTaskId
        workflowVersion
        workflowStepId
        modifiedOn
        modifiedBy
        dependsOn
        immediateNextTo
        sameAssigneeAs
        sameStartTimeAs
        sameLocationAs
        isDeleted
        delayMinutes
        resolvedBy
        resolvedOn
        linkedTaskIds
        template
        approvalStatus
        watcherIds
        parts {
          picklistId
          picklistOptionId
          quantity
        }
        formSchemaId
        formSectionId
        globalAttributes
        approvalInfo
        approverIds
        isApprovalWorkflow
        requestorIds
        onlyAllowManualScoreUpdate
        rejectedIds {
          id
          rejectedOn
        }
        scheduled
        taskNumber
        isTaskCopied
        watcherGroupIds
        timeToNextPriority
        isTaskLocked
        draftState
        readingId
        rulesEvaluated
        triggeredSourceTaskId
        generateMultiple
        copyGenerateMultipleAssignee
        nightShiftStartTime
        assetLevelsInfo
        nextRecurrenceDate
        prevRecurrenceDate
        statusAudit
        priorityScore
        score
        increment
      }
      vendorId
    }
  }
`;
export const onChangeUserTask = /* GraphQL */ `
  subscription OnChangeUserTask($userId: String, $vendorId: String) {
    onChangeUserTask(userId: $userId, vendorId: $vendorId) {
      userId
      taskId
      vendorId
    }
  }
`;
export const onChangeFieldTask = /* GraphQL */ `
  subscription OnChangeFieldTask($fieldId: String, $vendorId: String) {
    onChangeFieldTask(fieldId: $fieldId, vendorId: $vendorId) {
      fieldId
      task {
        approvedBy
        approvedOn
        asset {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        assetId
        assignee
        assigneeIds {
          assigneeId
          sequence
          isDeleted
          isAccepted
          acceptedOn
          vendorId
          operatorId
        }
        assignedOn
        attachments {
          bucket
          key
          region
          fileName
        }
        completedOn
        createdOn
        createdBy
        data
        duration
        endTime
        eventSource
        isRecurring
        fieldId
        id
        isHardAssignee
        isPlanned
        recurrenceInactive
        priority
        schedule {
          rrule
          startDate
          endDate
          recurrencePattern
          type
          displayUptoDays
          allowPileups
          overwriteEditedOccurrences
        }
        sourceRecurringTaskId
        originalRecurrenceDate
        deletedForRecurrenceDates
        isHardStartTime
        startTime
        status
        taskType {
          id
          duration
          priority
          score
          increment
          name
          schema
          teamId
          tenantId
          fieldId
          isParent
          autoApprove
          workflowVersions {
            version
            workflowSteps {
              workflowStepId
              taskTypeId
              dependsOn
              immediateNextTo
              sameAssigneeAs
              sameStartTimeAs
              formSectionId
              preferredLocationTypeId
              priorityTemplate
              assigneeIds
              sameLocationAs
              autoResolveDependsOn
            }
          }
          publishedVersion
          createdOn
          createdBy
          modifiedOn
          modifiedBy
          isDeleted
          needAcceptance
          enforceTimeSpent
          enforceComment
          enableReassign
          enableAutoAssign
          hasFormAttributes
          isLinkable
          certificates {
            id
            name
            isExpirable
            expiryDate
          }
          skillLevel {
            id
            name
            value
          }
          resolveOnArchive
          partsPicklist
          formSchemaId
          approvalMatrix
          disableCreateOnMobile
          disableAssignOnMobile
          disablePriorityOnMobile
          disableWorkOrderOnMobile
          disableDateOnMobile
          disableAssetOnMobile
          resolveOnGeofence
          excludeByRoutingEngine
          disablePrioritySelectionOnMobile
          disableEditingResolvedOnMobile
          taskTypeCode
          generateMultiple
          globalAttributes
          reminder {
            enableReminder
            reminderTime {
              days
              hours
              minutes
            }
          }
          attachmentIds
          instructionIds
          notification {
            notificationProfile
            notificationConfig {
              actionType
              userTypeForEmail
              userTypeForPushNotification
              sectionsToIncludeInEmail
            }
          }
          notificationProfile
          actionsEnabled
          userType
          fullManualMode
          singleActiveTask
          mandatoryWatcherGroups
          priorityTemplate
          priorityAlias
          rt_id
          needEquipment
          mandatoryAssignee
          autoAssignFirstChildToCreator
          triggerTasksUsingRules
          groups {
            id
            name
          }
          watcherGroupConfig {
            entityId
            entityPicklistWatcherGroupMappingId
            entityType
          }
          generateMultipleLabelName
          isDynamicParentChild
          rollupGlobalAttributes
          allowAssetLevelsInfo
          allowTaskCreationWithResolvedStatus
          autoResolveFirstTask
          defaultLocationTask
          allowedTeamsAsWatchers
        }
        taskTypeId
        tenantId
        parentTaskId
        workflowVersion
        workflowStepId
        modifiedOn
        modifiedBy
        dependsOn
        immediateNextTo
        sameAssigneeAs
        sameStartTimeAs
        sameLocationAs
        isDeleted
        delayMinutes
        resolvedBy
        resolvedOn
        linkedTaskIds
        template
        approvalStatus
        watcherIds
        parts {
          picklistId
          picklistOptionId
          quantity
        }
        formSchemaId
        formSectionId
        globalAttributes
        approvalInfo
        approverIds
        isApprovalWorkflow
        requestorIds
        onlyAllowManualScoreUpdate
        rejectedIds {
          id
          rejectedOn
        }
        scheduled
        taskNumber
        isTaskCopied
        watcherGroupIds
        timeToNextPriority
        isTaskLocked
        draftState
        readingId
        rulesEvaluated
        triggeredSourceTaskId
        generateMultiple
        copyGenerateMultipleAssignee
        nightShiftStartTime
        assetLevelsInfo
        nextRecurrenceDate
        prevRecurrenceDate
        statusAudit
        priorityScore
        score
        increment
      }
      vendorId
    }
  }
`;
export const onUserLocationUpdate = /* GraphQL */ `
  subscription OnUserLocationUpdate($fieldId: String) {
    onUserLocationUpdate(fieldId: $fieldId) {
      fieldId
      usersLocation
    }
  }
`;
export const onUserNotificationUpdate = /* GraphQL */ `
  subscription OnUserNotificationUpdate($userId: String) {
    onUserNotificationUpdate(userId: $userId) {
      userId
      usersNotification
    }
  }
`;
export const onChangeUser = /* GraphQL */ `
  subscription OnChangeUser($areaId: String, $vendorId: String) {
    onChangeUser(areaId: $areaId, vendorId: $vendorId) {
      areaId
      user {
        id
        xid
        sourceSystem
        tenantId
        fieldId
        userName
        firstName
        lastName
        email
        phone
        deviceId
        startLatitude
        startLongitude
        endLatitude
        endLongitude
        currentLatitude
        currentLongitude
        shiftStartTime
        shiftEndTime
        startStopId
        endStopId
        contractHourlyRate
        certificates {
          id
          name
          isExpirable
          expiryDate
        }
        skillLevel {
          id
          name
          value
        }
        activityStatus
        hitch {
          hitchStartDate
          hitchPattern {
            hitchWorkDays
            hitchOffDays
            sortOrder
          }
        }
        teams {
          userId
          teamId
          isDeleted
          isTeamLead
          isTeamMember
        }
        roles {
          userId
          roleId
          isDeleted
        }
        contacts
        defaultContact
        offDays
        onDays
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        isDeleted
        timeZone
        aws_ds
        locationUpdatedOn
        deviceMetadata
        vendorId
        aclQualifiedId
        contractInfoId
        businessTitle
        joyn2Roles
        signatureObject {
          bucket
          key
          region
          fileName
        }
        approver
        iscreatedFromFSM
        cognitoUserName
        mobileSettings
        isEquipmentResource
        operatorId
        accessCreatedBy
        shareCreatedWith
        allowReassignmentOnMobile
      }
      vendorId
    }
  }
`;
export const onBulkUserChange = /* GraphQL */ `
  subscription OnBulkUserChange($fieldId: String) {
    onBulkUserChange(fieldId: $fieldId) {
      fieldId
      usersInfo
    }
  }
`;
export const onChangeAreaFeed = /* GraphQL */ `
  subscription OnChangeAreaFeed($areaId: String, $vendorId: String) {
    onChangeAreaFeed(areaId: $areaId, vendorId: $vendorId) {
      areaId
      feed {
        data
        fieldId
        id
        tenantId
        userId
        areaIds
        createdOn
        createdBy
        modifiedBy
        modifiedOn
        isDeleted
      }
      vendorId
    }
  }
`;
export const onCreateAsset = /* GraphQL */ `
  subscription OnCreateAsset($fieldId: String, $tenantId: String) {
    onCreateAsset(fieldId: $fieldId, tenantId: $tenantId) {
      id
      tenantId
      fieldId
      xid
      fdgxid
      cxid
      sourceSystem
      name
      type
      subType
      areas {
        areaId
        isDeleted
      }
      teams {
        teamId
        resources {
          userId
          resourceLevel
          isDeleted
        }
        isDeleted
      }
      routes
      fdgRouteId
      fdgRouteIds
      fdgObjectId
      stopId
      stop {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      latitude
      longitude
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      aws_ds
      isDeleted
      areaType
      areaDefinition {
        version
        criteria {
          attributeName
          values
        }
      }
      customAttributes
      bulkStopGroupName
      producingMethodId
      productType
      tankStrappingID
      attachments {
        bucket
        key
        region
        fileName
      }
      watchers
      contacts
      preferredLocations
      geofence
      additionalStopIds
      hierarchy
    }
  }
`;
export const onCreateComment = /* GraphQL */ `
  subscription OnCreateComment($fieldId: String, $tenantId: String) {
    onCreateComment(fieldId: $fieldId, tenantId: $tenantId) {
      assets
      attachments {
        bucket
        key
        region
        fileName
      }
      comment
      createdOn
      createdBy
      modifiedBy
      modifiedOn
      fieldId
      id
      taskId
      assetId
      tenantId
      users
      isDeleted
      autoGenerated
    }
  }
`;
export const onCreateFeed = /* GraphQL */ `
  subscription OnCreateFeed(
    $fieldId: String
    $tenantId: String
    $userId: String
  ) {
    onCreateFeed(fieldId: $fieldId, tenantId: $tenantId, userId: $userId) {
      data
      fieldId
      id
      tenantId
      userId
      areaIds
      createdOn
      createdBy
      modifiedBy
      modifiedOn
      isDeleted
    }
  }
`;
export const onCreateSettings = /* GraphQL */ `
  subscription OnCreateSettings($id: ID, $settings: AWSJSON) {
    onCreateSettings(id: $id, settings: $settings) {
      id
      admin
      common
      app
      settings
      mapTilerSettings
      runEngineSettings
      automateDailyRunSettings
      featureFlags
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      created_at
      created_by
      updated_at
      updated_by
      tenantAuthCache
      fdgsssidCache
    }
  }
`;
export const onCreateTask = /* GraphQL */ `
  subscription OnCreateTask($fieldId: String, $tenantId: String) {
    onCreateTask(fieldId: $fieldId, tenantId: $tenantId) {
      approvedBy
      approvedOn
      asset {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      assetId
      assignee
      assigneeIds {
        assigneeId
        sequence
        isDeleted
        isAccepted
        acceptedOn
        vendorId
        operatorId
      }
      assignedOn
      attachments {
        bucket
        key
        region
        fileName
      }
      completedOn
      createdOn
      createdBy
      data
      duration
      endTime
      eventSource
      isRecurring
      fieldId
      id
      isHardAssignee
      isPlanned
      recurrenceInactive
      priority
      schedule {
        rrule
        startDate
        endDate
        recurrencePattern
        type
        displayUptoDays
        allowPileups
        overwriteEditedOccurrences
      }
      sourceRecurringTaskId
      originalRecurrenceDate
      deletedForRecurrenceDates
      isHardStartTime
      startTime
      status
      taskType {
        id
        duration
        priority
        score
        increment
        name
        schema
        teamId
        tenantId
        fieldId
        isParent
        autoApprove
        workflowVersions {
          version
          workflowSteps {
            workflowStepId
            taskTypeId
            dependsOn
            immediateNextTo
            sameAssigneeAs
            sameStartTimeAs
            formSectionId
            preferredLocationTypeId
            priorityTemplate
            assigneeIds
            sameLocationAs
            autoResolveDependsOn
          }
        }
        publishedVersion
        createdOn
        createdBy
        modifiedOn
        modifiedBy
        isDeleted
        needAcceptance
        enforceTimeSpent
        enforceComment
        enableReassign
        enableAutoAssign
        hasFormAttributes
        isLinkable
        certificates {
          id
          name
          isExpirable
          expiryDate
        }
        skillLevel {
          id
          name
          value
        }
        resolveOnArchive
        partsPicklist
        formSchemaId
        approvalMatrix
        disableCreateOnMobile
        disableAssignOnMobile
        disablePriorityOnMobile
        disableWorkOrderOnMobile
        disableDateOnMobile
        disableAssetOnMobile
        resolveOnGeofence
        excludeByRoutingEngine
        disablePrioritySelectionOnMobile
        disableEditingResolvedOnMobile
        taskTypeCode
        generateMultiple
        globalAttributes
        reminder {
          enableReminder
          reminderTime {
            days
            hours
            minutes
          }
        }
        attachmentIds
        instructionIds
        notification {
          notificationProfile
          notificationConfig {
            actionType
            userTypeForEmail
            userTypeForPushNotification
            sectionsToIncludeInEmail
          }
        }
        notificationProfile
        actionsEnabled
        userType
        fullManualMode
        singleActiveTask
        mandatoryWatcherGroups
        priorityTemplate
        priorityAlias
        rt_id
        needEquipment
        mandatoryAssignee
        autoAssignFirstChildToCreator
        triggerTasksUsingRules
        groups {
          id
          name
        }
        watcherGroupConfig {
          entityId
          entityPicklistWatcherGroupMappingId
          entityType
        }
        generateMultipleLabelName
        isDynamicParentChild
        rollupGlobalAttributes
        allowAssetLevelsInfo
        allowTaskCreationWithResolvedStatus
        autoResolveFirstTask
        defaultLocationTask
        allowedTeamsAsWatchers
      }
      taskTypeId
      tenantId
      parentTaskId
      workflowVersion
      workflowStepId
      modifiedOn
      modifiedBy
      dependsOn
      immediateNextTo
      sameAssigneeAs
      sameStartTimeAs
      sameLocationAs
      isDeleted
      delayMinutes
      resolvedBy
      resolvedOn
      linkedTaskIds
      template
      approvalStatus
      watcherIds
      parts {
        picklistId
        picklistOptionId
        quantity
      }
      formSchemaId
      formSectionId
      globalAttributes
      approvalInfo
      approverIds
      isApprovalWorkflow
      requestorIds
      onlyAllowManualScoreUpdate
      rejectedIds {
        id
        rejectedOn
      }
      scheduled
      taskNumber
      isTaskCopied
      watcherGroupIds
      timeToNextPriority
      isTaskLocked
      draftState
      readingId
      rulesEvaluated
      triggeredSourceTaskId
      generateMultiple
      copyGenerateMultipleAssignee
      nightShiftStartTime
      assetLevelsInfo
      nextRecurrenceDate
      prevRecurrenceDate
      statusAudit
      priorityScore
      score
      increment
    }
  }
`;
export const onCreateTaskType = /* GraphQL */ `
  subscription OnCreateTaskType($tenantId: String) {
    onCreateTaskType(tenantId: $tenantId) {
      id
      duration
      priority
      score
      increment
      name
      schema
      teamId
      tenantId
      fieldId
      isParent
      autoApprove
      workflowVersions {
        version
        workflowSteps {
          workflowStepId
          taskTypeId
          dependsOn
          immediateNextTo
          sameAssigneeAs
          sameStartTimeAs
          formSectionId
          preferredLocationTypeId
          priorityTemplate
          assigneeIds
          sameLocationAs
          autoResolveDependsOn
        }
      }
      publishedVersion
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      isDeleted
      needAcceptance
      enforceTimeSpent
      enforceComment
      enableReassign
      enableAutoAssign
      hasFormAttributes
      isLinkable
      certificates {
        id
        name
        isExpirable
        expiryDate
      }
      skillLevel {
        id
        name
        value
      }
      resolveOnArchive
      partsPicklist
      formSchemaId
      approvalMatrix
      disableCreateOnMobile
      disableAssignOnMobile
      disablePriorityOnMobile
      disableWorkOrderOnMobile
      disableDateOnMobile
      disableAssetOnMobile
      resolveOnGeofence
      excludeByRoutingEngine
      disablePrioritySelectionOnMobile
      disableEditingResolvedOnMobile
      taskTypeCode
      generateMultiple
      globalAttributes
      reminder {
        enableReminder
        reminderTime {
          days
          hours
          minutes
        }
      }
      attachmentIds
      instructionIds
      notification {
        notificationProfile
        notificationConfig {
          actionType
          userTypeForEmail
          userTypeForPushNotification
          sectionsToIncludeInEmail
        }
      }
      notificationProfile
      actionsEnabled
      userType
      fullManualMode
      singleActiveTask
      mandatoryWatcherGroups
      priorityTemplate
      priorityAlias
      rt_id
      needEquipment
      mandatoryAssignee
      autoAssignFirstChildToCreator
      triggerTasksUsingRules
      groups {
        id
        name
      }
      watcherGroupConfig {
        entityId
        entityPicklistWatcherGroupMappingId
        entityType
      }
      generateMultipleLabelName
      isDynamicParentChild
      rollupGlobalAttributes
      allowAssetLevelsInfo
      allowTaskCreationWithResolvedStatus
      autoResolveFirstTask
      defaultLocationTask
      allowedTeamsAsWatchers
    }
  }
`;
export const onCreateTenant = /* GraphQL */ `
  subscription OnCreateTenant($id: ID, $name: String) {
    onCreateTenant(id: $id, name: $name) {
      id
      name
      created_at
      created_by
      updated_at
      updated_by
    }
  }
`;
export const onDeleteAsset = /* GraphQL */ `
  subscription OnDeleteAsset($fieldId: String, $tenantId: String) {
    onDeleteAsset(fieldId: $fieldId, tenantId: $tenantId) {
      id
      tenantId
      fieldId
      xid
      fdgxid
      cxid
      sourceSystem
      name
      type
      subType
      areas {
        areaId
        isDeleted
      }
      teams {
        teamId
        resources {
          userId
          resourceLevel
          isDeleted
        }
        isDeleted
      }
      routes
      fdgRouteId
      fdgRouteIds
      fdgObjectId
      stopId
      stop {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      latitude
      longitude
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      aws_ds
      isDeleted
      areaType
      areaDefinition {
        version
        criteria {
          attributeName
          values
        }
      }
      customAttributes
      bulkStopGroupName
      producingMethodId
      productType
      tankStrappingID
      attachments {
        bucket
        key
        region
        fileName
      }
      watchers
      contacts
      preferredLocations
      geofence
      additionalStopIds
      hierarchy
    }
  }
`;
export const onDeleteComment = /* GraphQL */ `
  subscription OnDeleteComment($fieldId: String, $tenantId: String) {
    onDeleteComment(fieldId: $fieldId, tenantId: $tenantId) {
      assets
      attachments {
        bucket
        key
        region
        fileName
      }
      comment
      createdOn
      createdBy
      modifiedBy
      modifiedOn
      fieldId
      id
      taskId
      assetId
      tenantId
      users
      isDeleted
      autoGenerated
    }
  }
`;
export const onDeleteFeed = /* GraphQL */ `
  subscription OnDeleteFeed(
    $fieldId: String
    $tenantId: String
    $userId: String
  ) {
    onDeleteFeed(fieldId: $fieldId, tenantId: $tenantId, userId: $userId) {
      data
      fieldId
      id
      tenantId
      userId
      areaIds
      createdOn
      createdBy
      modifiedBy
      modifiedOn
      isDeleted
    }
  }
`;
export const onDeleteSettings = /* GraphQL */ `
  subscription OnDeleteSettings($id: ID, $settings: AWSJSON) {
    onDeleteSettings(id: $id, settings: $settings) {
      id
      admin
      common
      app
      settings
      mapTilerSettings
      runEngineSettings
      automateDailyRunSettings
      featureFlags
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      created_at
      created_by
      updated_at
      updated_by
      tenantAuthCache
      fdgsssidCache
    }
  }
`;
export const onDeleteTask = /* GraphQL */ `
  subscription OnDeleteTask($fieldId: String, $tenantId: String) {
    onDeleteTask(fieldId: $fieldId, tenantId: $tenantId) {
      approvedBy
      approvedOn
      asset {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      assetId
      assignee
      assigneeIds {
        assigneeId
        sequence
        isDeleted
        isAccepted
        acceptedOn
        vendorId
        operatorId
      }
      assignedOn
      attachments {
        bucket
        key
        region
        fileName
      }
      completedOn
      createdOn
      createdBy
      data
      duration
      endTime
      eventSource
      isRecurring
      fieldId
      id
      isHardAssignee
      isPlanned
      recurrenceInactive
      priority
      schedule {
        rrule
        startDate
        endDate
        recurrencePattern
        type
        displayUptoDays
        allowPileups
        overwriteEditedOccurrences
      }
      sourceRecurringTaskId
      originalRecurrenceDate
      deletedForRecurrenceDates
      isHardStartTime
      startTime
      status
      taskType {
        id
        duration
        priority
        score
        increment
        name
        schema
        teamId
        tenantId
        fieldId
        isParent
        autoApprove
        workflowVersions {
          version
          workflowSteps {
            workflowStepId
            taskTypeId
            dependsOn
            immediateNextTo
            sameAssigneeAs
            sameStartTimeAs
            formSectionId
            preferredLocationTypeId
            priorityTemplate
            assigneeIds
            sameLocationAs
            autoResolveDependsOn
          }
        }
        publishedVersion
        createdOn
        createdBy
        modifiedOn
        modifiedBy
        isDeleted
        needAcceptance
        enforceTimeSpent
        enforceComment
        enableReassign
        enableAutoAssign
        hasFormAttributes
        isLinkable
        certificates {
          id
          name
          isExpirable
          expiryDate
        }
        skillLevel {
          id
          name
          value
        }
        resolveOnArchive
        partsPicklist
        formSchemaId
        approvalMatrix
        disableCreateOnMobile
        disableAssignOnMobile
        disablePriorityOnMobile
        disableWorkOrderOnMobile
        disableDateOnMobile
        disableAssetOnMobile
        resolveOnGeofence
        excludeByRoutingEngine
        disablePrioritySelectionOnMobile
        disableEditingResolvedOnMobile
        taskTypeCode
        generateMultiple
        globalAttributes
        reminder {
          enableReminder
          reminderTime {
            days
            hours
            minutes
          }
        }
        attachmentIds
        instructionIds
        notification {
          notificationProfile
          notificationConfig {
            actionType
            userTypeForEmail
            userTypeForPushNotification
            sectionsToIncludeInEmail
          }
        }
        notificationProfile
        actionsEnabled
        userType
        fullManualMode
        singleActiveTask
        mandatoryWatcherGroups
        priorityTemplate
        priorityAlias
        rt_id
        needEquipment
        mandatoryAssignee
        autoAssignFirstChildToCreator
        triggerTasksUsingRules
        groups {
          id
          name
        }
        watcherGroupConfig {
          entityId
          entityPicklistWatcherGroupMappingId
          entityType
        }
        generateMultipleLabelName
        isDynamicParentChild
        rollupGlobalAttributes
        allowAssetLevelsInfo
        allowTaskCreationWithResolvedStatus
        autoResolveFirstTask
        defaultLocationTask
        allowedTeamsAsWatchers
      }
      taskTypeId
      tenantId
      parentTaskId
      workflowVersion
      workflowStepId
      modifiedOn
      modifiedBy
      dependsOn
      immediateNextTo
      sameAssigneeAs
      sameStartTimeAs
      sameLocationAs
      isDeleted
      delayMinutes
      resolvedBy
      resolvedOn
      linkedTaskIds
      template
      approvalStatus
      watcherIds
      parts {
        picklistId
        picklistOptionId
        quantity
      }
      formSchemaId
      formSectionId
      globalAttributes
      approvalInfo
      approverIds
      isApprovalWorkflow
      requestorIds
      onlyAllowManualScoreUpdate
      rejectedIds {
        id
        rejectedOn
      }
      scheduled
      taskNumber
      isTaskCopied
      watcherGroupIds
      timeToNextPriority
      isTaskLocked
      draftState
      readingId
      rulesEvaluated
      triggeredSourceTaskId
      generateMultiple
      copyGenerateMultipleAssignee
      nightShiftStartTime
      assetLevelsInfo
      nextRecurrenceDate
      prevRecurrenceDate
      statusAudit
      priorityScore
      score
      increment
    }
  }
`;
export const onDeleteTaskType = /* GraphQL */ `
  subscription OnDeleteTaskType($tenantId: String) {
    onDeleteTaskType(tenantId: $tenantId) {
      id
      duration
      priority
      score
      increment
      name
      schema
      teamId
      tenantId
      fieldId
      isParent
      autoApprove
      workflowVersions {
        version
        workflowSteps {
          workflowStepId
          taskTypeId
          dependsOn
          immediateNextTo
          sameAssigneeAs
          sameStartTimeAs
          formSectionId
          preferredLocationTypeId
          priorityTemplate
          assigneeIds
          sameLocationAs
          autoResolveDependsOn
        }
      }
      publishedVersion
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      isDeleted
      needAcceptance
      enforceTimeSpent
      enforceComment
      enableReassign
      enableAutoAssign
      hasFormAttributes
      isLinkable
      certificates {
        id
        name
        isExpirable
        expiryDate
      }
      skillLevel {
        id
        name
        value
      }
      resolveOnArchive
      partsPicklist
      formSchemaId
      approvalMatrix
      disableCreateOnMobile
      disableAssignOnMobile
      disablePriorityOnMobile
      disableWorkOrderOnMobile
      disableDateOnMobile
      disableAssetOnMobile
      resolveOnGeofence
      excludeByRoutingEngine
      disablePrioritySelectionOnMobile
      disableEditingResolvedOnMobile
      taskTypeCode
      generateMultiple
      globalAttributes
      reminder {
        enableReminder
        reminderTime {
          days
          hours
          minutes
        }
      }
      attachmentIds
      instructionIds
      notification {
        notificationProfile
        notificationConfig {
          actionType
          userTypeForEmail
          userTypeForPushNotification
          sectionsToIncludeInEmail
        }
      }
      notificationProfile
      actionsEnabled
      userType
      fullManualMode
      singleActiveTask
      mandatoryWatcherGroups
      priorityTemplate
      priorityAlias
      rt_id
      needEquipment
      mandatoryAssignee
      autoAssignFirstChildToCreator
      triggerTasksUsingRules
      groups {
        id
        name
      }
      watcherGroupConfig {
        entityId
        entityPicklistWatcherGroupMappingId
        entityType
      }
      generateMultipleLabelName
      isDynamicParentChild
      rollupGlobalAttributes
      allowAssetLevelsInfo
      allowTaskCreationWithResolvedStatus
      autoResolveFirstTask
      defaultLocationTask
      allowedTeamsAsWatchers
    }
  }
`;
export const onDeleteTenant = /* GraphQL */ `
  subscription OnDeleteTenant($id: ID, $name: String) {
    onDeleteTenant(id: $id, name: $name) {
      id
      name
      created_at
      created_by
      updated_at
      updated_by
    }
  }
`;
export const onUpdateAsset = /* GraphQL */ `
  subscription OnUpdateAsset($fieldId: String, $tenantId: String) {
    onUpdateAsset(fieldId: $fieldId, tenantId: $tenantId) {
      id
      tenantId
      fieldId
      xid
      fdgxid
      cxid
      sourceSystem
      name
      type
      subType
      areas {
        areaId
        isDeleted
      }
      teams {
        teamId
        resources {
          userId
          resourceLevel
          isDeleted
        }
        isDeleted
      }
      routes
      fdgRouteId
      fdgRouteIds
      fdgObjectId
      stopId
      stop {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      latitude
      longitude
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      aws_ds
      isDeleted
      areaType
      areaDefinition {
        version
        criteria {
          attributeName
          values
        }
      }
      customAttributes
      bulkStopGroupName
      producingMethodId
      productType
      tankStrappingID
      attachments {
        bucket
        key
        region
        fileName
      }
      watchers
      contacts
      preferredLocations
      geofence
      additionalStopIds
      hierarchy
    }
  }
`;
export const onUpdateComment = /* GraphQL */ `
  subscription OnUpdateComment($fieldId: String, $tenantId: String) {
    onUpdateComment(fieldId: $fieldId, tenantId: $tenantId) {
      assets
      attachments {
        bucket
        key
        region
        fileName
      }
      comment
      createdOn
      createdBy
      modifiedBy
      modifiedOn
      fieldId
      id
      taskId
      assetId
      tenantId
      users
      isDeleted
      autoGenerated
    }
  }
`;
export const onUpdateFeed = /* GraphQL */ `
  subscription OnUpdateFeed(
    $fieldId: String
    $tenantId: String
    $userId: String
  ) {
    onUpdateFeed(fieldId: $fieldId, tenantId: $tenantId, userId: $userId) {
      data
      fieldId
      id
      tenantId
      userId
      areaIds
      createdOn
      createdBy
      modifiedBy
      modifiedOn
      isDeleted
    }
  }
`;
export const onUpdateSettings = /* GraphQL */ `
  subscription OnUpdateSettings($id: ID, $settings: AWSJSON) {
    onUpdateSettings(id: $id, settings: $settings) {
      id
      admin
      common
      app
      settings
      mapTilerSettings
      runEngineSettings
      automateDailyRunSettings
      featureFlags
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      created_at
      created_by
      updated_at
      updated_by
      tenantAuthCache
      fdgsssidCache
    }
  }
`;
export const onUpdateTask = /* GraphQL */ `
  subscription OnUpdateTask($fieldId: String, $tenantId: String) {
    onUpdateTask(fieldId: $fieldId, tenantId: $tenantId) {
      approvedBy
      approvedOn
      asset {
        id
        tenantId
        fieldId
        xid
        fdgxid
        cxid
        sourceSystem
        name
        type
        subType
        areas {
          areaId
          isDeleted
        }
        teams {
          teamId
          resources {
            userId
            resourceLevel
            isDeleted
          }
          isDeleted
        }
        routes
        fdgRouteId
        fdgRouteIds
        fdgObjectId
        stopId
        stop {
          id
          tenantId
          fieldId
          xid
          fdgxid
          cxid
          sourceSystem
          name
          type
          subType
          areas {
            areaId
            isDeleted
          }
          teams {
            teamId
            resources {
              userId
              resourceLevel
              isDeleted
            }
            isDeleted
          }
          routes
          fdgRouteId
          fdgRouteIds
          fdgObjectId
          stopId
          stop {
            id
            tenantId
            fieldId
            xid
            fdgxid
            cxid
            sourceSystem
            name
            type
            subType
            areas {
              areaId
              isDeleted
            }
            teams {
              teamId
              resources {
                userId
                resourceLevel
                isDeleted
              }
              isDeleted
            }
            routes
            fdgRouteId
            fdgRouteIds
            fdgObjectId
            stopId
            stop {
              id
              tenantId
              fieldId
              xid
              fdgxid
              cxid
              sourceSystem
              name
              type
              subType
              areas {
                areaId
                isDeleted
              }
              teams {
                teamId
                isDeleted
              }
              routes
              fdgRouteId
              fdgRouteIds
              fdgObjectId
              stopId
              stop {
                id
                tenantId
                fieldId
                xid
                fdgxid
                cxid
                sourceSystem
                name
                type
                subType
                routes
                fdgRouteId
                fdgRouteIds
                fdgObjectId
                stopId
                latitude
                longitude
                createdBy
                modifiedBy
                createdOn
                modifiedOn
                aws_ds
                isDeleted
                areaType
                customAttributes
                bulkStopGroupName
                producingMethodId
                productType
                tankStrappingID
                watchers
                contacts
                preferredLocations
                geofence
                additionalStopIds
                hierarchy
              }
              latitude
              longitude
              createdBy
              modifiedBy
              createdOn
              modifiedOn
              aws_ds
              isDeleted
              areaType
              areaDefinition {
                version
              }
              customAttributes
              bulkStopGroupName
              producingMethodId
              productType
              tankStrappingID
              attachments {
                bucket
                key
                region
                fileName
              }
              watchers
              contacts
              preferredLocations
              geofence
              additionalStopIds
              hierarchy
            }
            latitude
            longitude
            createdBy
            modifiedBy
            createdOn
            modifiedOn
            aws_ds
            isDeleted
            areaType
            areaDefinition {
              version
              criteria {
                attributeName
                values
              }
            }
            customAttributes
            bulkStopGroupName
            producingMethodId
            productType
            tankStrappingID
            attachments {
              bucket
              key
              region
              fileName
            }
            watchers
            contacts
            preferredLocations
            geofence
            additionalStopIds
            hierarchy
          }
          latitude
          longitude
          createdBy
          modifiedBy
          createdOn
          modifiedOn
          aws_ds
          isDeleted
          areaType
          areaDefinition {
            version
            criteria {
              attributeName
              values
            }
          }
          customAttributes
          bulkStopGroupName
          producingMethodId
          productType
          tankStrappingID
          attachments {
            bucket
            key
            region
            fileName
          }
          watchers
          contacts
          preferredLocations
          geofence
          additionalStopIds
          hierarchy
        }
        latitude
        longitude
        createdBy
        modifiedBy
        createdOn
        modifiedOn
        aws_ds
        isDeleted
        areaType
        areaDefinition {
          version
          criteria {
            attributeName
            values
          }
        }
        customAttributes
        bulkStopGroupName
        producingMethodId
        productType
        tankStrappingID
        attachments {
          bucket
          key
          region
          fileName
        }
        watchers
        contacts
        preferredLocations
        geofence
        additionalStopIds
        hierarchy
      }
      assetId
      assignee
      assigneeIds {
        assigneeId
        sequence
        isDeleted
        isAccepted
        acceptedOn
        vendorId
        operatorId
      }
      assignedOn
      attachments {
        bucket
        key
        region
        fileName
      }
      completedOn
      createdOn
      createdBy
      data
      duration
      endTime
      eventSource
      isRecurring
      fieldId
      id
      isHardAssignee
      isPlanned
      recurrenceInactive
      priority
      schedule {
        rrule
        startDate
        endDate
        recurrencePattern
        type
        displayUptoDays
        allowPileups
        overwriteEditedOccurrences
      }
      sourceRecurringTaskId
      originalRecurrenceDate
      deletedForRecurrenceDates
      isHardStartTime
      startTime
      status
      taskType {
        id
        duration
        priority
        score
        increment
        name
        schema
        teamId
        tenantId
        fieldId
        isParent
        autoApprove
        workflowVersions {
          version
          workflowSteps {
            workflowStepId
            taskTypeId
            dependsOn
            immediateNextTo
            sameAssigneeAs
            sameStartTimeAs
            formSectionId
            preferredLocationTypeId
            priorityTemplate
            assigneeIds
            sameLocationAs
            autoResolveDependsOn
          }
        }
        publishedVersion
        createdOn
        createdBy
        modifiedOn
        modifiedBy
        isDeleted
        needAcceptance
        enforceTimeSpent
        enforceComment
        enableReassign
        enableAutoAssign
        hasFormAttributes
        isLinkable
        certificates {
          id
          name
          isExpirable
          expiryDate
        }
        skillLevel {
          id
          name
          value
        }
        resolveOnArchive
        partsPicklist
        formSchemaId
        approvalMatrix
        disableCreateOnMobile
        disableAssignOnMobile
        disablePriorityOnMobile
        disableWorkOrderOnMobile
        disableDateOnMobile
        disableAssetOnMobile
        resolveOnGeofence
        excludeByRoutingEngine
        disablePrioritySelectionOnMobile
        disableEditingResolvedOnMobile
        taskTypeCode
        generateMultiple
        globalAttributes
        reminder {
          enableReminder
          reminderTime {
            days
            hours
            minutes
          }
        }
        attachmentIds
        instructionIds
        notification {
          notificationProfile
          notificationConfig {
            actionType
            userTypeForEmail
            userTypeForPushNotification
            sectionsToIncludeInEmail
          }
        }
        notificationProfile
        actionsEnabled
        userType
        fullManualMode
        singleActiveTask
        mandatoryWatcherGroups
        priorityTemplate
        priorityAlias
        rt_id
        needEquipment
        mandatoryAssignee
        autoAssignFirstChildToCreator
        triggerTasksUsingRules
        groups {
          id
          name
        }
        watcherGroupConfig {
          entityId
          entityPicklistWatcherGroupMappingId
          entityType
        }
        generateMultipleLabelName
        isDynamicParentChild
        rollupGlobalAttributes
        allowAssetLevelsInfo
        allowTaskCreationWithResolvedStatus
        autoResolveFirstTask
        defaultLocationTask
        allowedTeamsAsWatchers
      }
      taskTypeId
      tenantId
      parentTaskId
      workflowVersion
      workflowStepId
      modifiedOn
      modifiedBy
      dependsOn
      immediateNextTo
      sameAssigneeAs
      sameStartTimeAs
      sameLocationAs
      isDeleted
      delayMinutes
      resolvedBy
      resolvedOn
      linkedTaskIds
      template
      approvalStatus
      watcherIds
      parts {
        picklistId
        picklistOptionId
        quantity
      }
      formSchemaId
      formSectionId
      globalAttributes
      approvalInfo
      approverIds
      isApprovalWorkflow
      requestorIds
      onlyAllowManualScoreUpdate
      rejectedIds {
        id
        rejectedOn
      }
      scheduled
      taskNumber
      isTaskCopied
      watcherGroupIds
      timeToNextPriority
      isTaskLocked
      draftState
      readingId
      rulesEvaluated
      triggeredSourceTaskId
      generateMultiple
      copyGenerateMultipleAssignee
      nightShiftStartTime
      assetLevelsInfo
      nextRecurrenceDate
      prevRecurrenceDate
      statusAudit
      priorityScore
      score
      increment
    }
  }
`;
export const onUpdateTaskType = /* GraphQL */ `
  subscription OnUpdateTaskType($tenantId: String) {
    onUpdateTaskType(tenantId: $tenantId) {
      id
      duration
      priority
      score
      increment
      name
      schema
      teamId
      tenantId
      fieldId
      isParent
      autoApprove
      workflowVersions {
        version
        workflowSteps {
          workflowStepId
          taskTypeId
          dependsOn
          immediateNextTo
          sameAssigneeAs
          sameStartTimeAs
          formSectionId
          preferredLocationTypeId
          priorityTemplate
          assigneeIds
          sameLocationAs
          autoResolveDependsOn
        }
      }
      publishedVersion
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      isDeleted
      needAcceptance
      enforceTimeSpent
      enforceComment
      enableReassign
      enableAutoAssign
      hasFormAttributes
      isLinkable
      certificates {
        id
        name
        isExpirable
        expiryDate
      }
      skillLevel {
        id
        name
        value
      }
      resolveOnArchive
      partsPicklist
      formSchemaId
      approvalMatrix
      disableCreateOnMobile
      disableAssignOnMobile
      disablePriorityOnMobile
      disableWorkOrderOnMobile
      disableDateOnMobile
      disableAssetOnMobile
      resolveOnGeofence
      excludeByRoutingEngine
      disablePrioritySelectionOnMobile
      disableEditingResolvedOnMobile
      taskTypeCode
      generateMultiple
      globalAttributes
      reminder {
        enableReminder
        reminderTime {
          days
          hours
          minutes
        }
      }
      attachmentIds
      instructionIds
      notification {
        notificationProfile
        notificationConfig {
          actionType
          userTypeForEmail
          userTypeForPushNotification
          sectionsToIncludeInEmail
        }
      }
      notificationProfile
      actionsEnabled
      userType
      fullManualMode
      singleActiveTask
      mandatoryWatcherGroups
      priorityTemplate
      priorityAlias
      rt_id
      needEquipment
      mandatoryAssignee
      autoAssignFirstChildToCreator
      triggerTasksUsingRules
      groups {
        id
        name
      }
      watcherGroupConfig {
        entityId
        entityPicklistWatcherGroupMappingId
        entityType
      }
      generateMultipleLabelName
      isDynamicParentChild
      rollupGlobalAttributes
      allowAssetLevelsInfo
      allowTaskCreationWithResolvedStatus
      autoResolveFirstTask
      defaultLocationTask
      allowedTeamsAsWatchers
    }
  }
`;
export const onUpdateTenant = /* GraphQL */ `
  subscription OnUpdateTenant($id: ID, $name: String) {
    onUpdateTenant(id: $id, name: $name) {
      id
      name
      created_at
      created_by
      updated_at
      updated_by
    }
  }
`;
export const onCreateTeam = /* GraphQL */ `
  subscription OnCreateTeam($id: ID, $name: String) {
    onCreateTeam(id: $id, name: $name) {
      id
      name
      tenantId
      fieldId
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      isDeleted
      aws_ds
      allowedTaskTypeCreateGroups {
        id
        name
      }
    }
  }
`;
export const onUpdateTeam = /* GraphQL */ `
  subscription OnUpdateTeam($id: ID, $name: String) {
    onUpdateTeam(id: $id, name: $name) {
      id
      name
      tenantId
      fieldId
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      isDeleted
      aws_ds
      allowedTaskTypeCreateGroups {
        id
        name
      }
    }
  }
`;
export const onDeleteTeam = /* GraphQL */ `
  subscription OnDeleteTeam($id: ID, $name: String) {
    onDeleteTeam(id: $id, name: $name) {
      id
      name
      tenantId
      fieldId
      createdOn
      createdBy
      modifiedOn
      modifiedBy
      isDeleted
      aws_ds
      allowedTaskTypeCreateGroups {
        id
        name
      }
    }
  }
`;
export const onCreateUser = /* GraphQL */ `
  subscription OnCreateUser($tenantId: String!, $fieldId: String!) {
    onCreateUser(tenantId: $tenantId, fieldId: $fieldId) {
      id
      xid
      sourceSystem
      tenantId
      fieldId
      userName
      firstName
      lastName
      email
      phone
      deviceId
      startLatitude
      startLongitude
      endLatitude
      endLongitude
      currentLatitude
      currentLongitude
      shiftStartTime
      shiftEndTime
      startStopId
      endStopId
      contractHourlyRate
      certificates {
        id
        name
        isExpirable
        expiryDate
      }
      skillLevel {
        id
        name
        value
      }
      activityStatus
      hitch {
        hitchStartDate
        hitchPattern {
          hitchWorkDays
          hitchOffDays
          sortOrder
        }
      }
      teams {
        userId
        teamId
        isDeleted
        isTeamLead
        isTeamMember
      }
      roles {
        userId
        roleId
        isDeleted
      }
      contacts
      defaultContact
      offDays
      onDays
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      isDeleted
      timeZone
      aws_ds
      locationUpdatedOn
      deviceMetadata
      vendorId
      aclQualifiedId
      contractInfoId
      businessTitle
      joyn2Roles
      signatureObject {
        bucket
        key
        region
        fileName
      }
      approver
      iscreatedFromFSM
      cognitoUserName
      mobileSettings
      isEquipmentResource
      operatorId
      accessCreatedBy
      shareCreatedWith
      allowReassignmentOnMobile
    }
  }
`;
export const onUpdateUser = /* GraphQL */ `
  subscription OnUpdateUser($tenantId: String!, $fieldId: String!) {
    onUpdateUser(tenantId: $tenantId, fieldId: $fieldId) {
      id
      xid
      sourceSystem
      tenantId
      fieldId
      userName
      firstName
      lastName
      email
      phone
      deviceId
      startLatitude
      startLongitude
      endLatitude
      endLongitude
      currentLatitude
      currentLongitude
      shiftStartTime
      shiftEndTime
      startStopId
      endStopId
      contractHourlyRate
      certificates {
        id
        name
        isExpirable
        expiryDate
      }
      skillLevel {
        id
        name
        value
      }
      activityStatus
      hitch {
        hitchStartDate
        hitchPattern {
          hitchWorkDays
          hitchOffDays
          sortOrder
        }
      }
      teams {
        userId
        teamId
        isDeleted
        isTeamLead
        isTeamMember
      }
      roles {
        userId
        roleId
        isDeleted
      }
      contacts
      defaultContact
      offDays
      onDays
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      isDeleted
      timeZone
      aws_ds
      locationUpdatedOn
      deviceMetadata
      vendorId
      aclQualifiedId
      contractInfoId
      businessTitle
      joyn2Roles
      signatureObject {
        bucket
        key
        region
        fileName
      }
      approver
      iscreatedFromFSM
      cognitoUserName
      mobileSettings
      isEquipmentResource
      operatorId
      accessCreatedBy
      shareCreatedWith
      allowReassignmentOnMobile
    }
  }
`;
export const onDeleteUser = /* GraphQL */ `
  subscription OnDeleteUser($tenantId: String!, $fieldId: String!) {
    onDeleteUser(tenantId: $tenantId, fieldId: $fieldId) {
      id
      xid
      sourceSystem
      tenantId
      fieldId
      userName
      firstName
      lastName
      email
      phone
      deviceId
      startLatitude
      startLongitude
      endLatitude
      endLongitude
      currentLatitude
      currentLongitude
      shiftStartTime
      shiftEndTime
      startStopId
      endStopId
      contractHourlyRate
      certificates {
        id
        name
        isExpirable
        expiryDate
      }
      skillLevel {
        id
        name
        value
      }
      activityStatus
      hitch {
        hitchStartDate
        hitchPattern {
          hitchWorkDays
          hitchOffDays
          sortOrder
        }
      }
      teams {
        userId
        teamId
        isDeleted
        isTeamLead
        isTeamMember
      }
      roles {
        userId
        roleId
        isDeleted
      }
      contacts
      defaultContact
      offDays
      onDays
      createdBy
      modifiedBy
      createdOn
      modifiedOn
      isDeleted
      timeZone
      aws_ds
      locationUpdatedOn
      deviceMetadata
      vendorId
      aclQualifiedId
      contractInfoId
      businessTitle
      joyn2Roles
      signatureObject {
        bucket
        key
        region
        fileName
      }
      approver
      iscreatedFromFSM
      cognitoUserName
      mobileSettings
      isEquipmentResource
      operatorId
      accessCreatedBy
      shareCreatedWith
      allowReassignmentOnMobile
    }
  }
`;
export const onCreateEntityAttribute = /* GraphQL */ `
  subscription OnCreateEntityAttribute(
    $id: ID
    $tenantId: String
    $xid: String
    $sourceSystem: String
    $attributeDisplayName: String
  ) {
    onCreateEntityAttribute(
      id: $id
      tenantId: $tenantId
      xid: $xid
      sourceSystem: $sourceSystem
      attributeDisplayName: $attributeDisplayName
    ) {
      id
      tenantId
      xid
      sourceSystem
      attributeDisplayName
      assetType
      attributeType
      attributeName
      isDeleted
    }
  }
`;
export const onUpdateEntityAttribute = /* GraphQL */ `
  subscription OnUpdateEntityAttribute(
    $id: ID
    $tenantId: String
    $xid: String
    $sourceSystem: String
    $attributeDisplayName: String
  ) {
    onUpdateEntityAttribute(
      id: $id
      tenantId: $tenantId
      xid: $xid
      sourceSystem: $sourceSystem
      attributeDisplayName: $attributeDisplayName
    ) {
      id
      tenantId
      xid
      sourceSystem
      attributeDisplayName
      assetType
      attributeType
      attributeName
      isDeleted
    }
  }
`;
export const onDeleteEntityAttribute = /* GraphQL */ `
  subscription OnDeleteEntityAttribute(
    $id: ID
    $tenantId: String
    $xid: String
    $sourceSystem: String
    $attributeDisplayName: String
  ) {
    onDeleteEntityAttribute(
      id: $id
      tenantId: $tenantId
      xid: $xid
      sourceSystem: $sourceSystem
      attributeDisplayName: $attributeDisplayName
    ) {
      id
      tenantId
      xid
      sourceSystem
      attributeDisplayName
      assetType
      attributeType
      attributeName
      isDeleted
    }
  }
`;
export const onUpdateRequestId = /* GraphQL */ `
  subscription OnUpdateRequestId($requestId: ID) {
    onUpdateRequestId(requestId: $requestId) {
      requestId
      success
      message
    }
  }
`;
export const onCreatePicklist = /* GraphQL */ `
  subscription OnCreatePicklist(
    $id: ID
    $name: String
    $parentId: String
    $tenantId: String
    $xid: String
  ) {
    onCreatePicklist(
      id: $id
      name: $name
      parentId: $parentId
      tenantId: $tenantId
      xid: $xid
    ) {
      createdBy
      createdOn
      desc
      id
      modifiedBy
      modifiedOn
      name
      options
      parentId
      tenantId
      xid
      isCustomizable
      displayName
    }
  }
`;
export const onDeletePicklist = /* GraphQL */ `
  subscription OnDeletePicklist(
    $id: ID
    $name: String
    $parentId: String
    $tenantId: String
    $xid: String
  ) {
    onDeletePicklist(
      id: $id
      name: $name
      parentId: $parentId
      tenantId: $tenantId
      xid: $xid
    ) {
      createdBy
      createdOn
      desc
      id
      modifiedBy
      modifiedOn
      name
      options
      parentId
      tenantId
      xid
      isCustomizable
      displayName
    }
  }
`;
export const onUpdatePicklist = /* GraphQL */ `
  subscription OnUpdatePicklist(
    $id: ID
    $name: String
    $parentId: String
    $tenantId: String
    $xid: String
  ) {
    onUpdatePicklist(
      id: $id
      name: $name
      parentId: $parentId
      tenantId: $tenantId
      xid: $xid
    ) {
      createdBy
      createdOn
      desc
      id
      modifiedBy
      modifiedOn
      name
      options
      parentId
      tenantId
      xid
      isCustomizable
      displayName
    }
  }
`;
